import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté
    const hasAccepted = localStorage.getItem('cookieConsent');
    
    if (!hasAccepted) {
      // Afficher avec un petit délai pour une meilleure UX
      const timer = setTimeout(() => {
        setIsVisible(true);
        setIsAnimating(true);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsAnimating(false);
    
    // Délai pour l'animation de sortie
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsAnimating(false);
    
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300 ${
          isAnimating ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleDecline}
      />
      
      {/* Popup */}
      <div 
        className={`fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-white rounded-xl shadow-2xl border border-gray-200 z-50 transform transition-all duration-300 ${
          isAnimating ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-full opacity-0 scale-95'
        }`}
      >
        <div className="p-6">
          {/* Header */}
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                <i className="fas fa-cookie-bite text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">
                Cookies et confidentialité
              </h3>
            </div>
            <button
              onClick={handleDecline}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Fermer"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Contenu */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">
              Nous utilisons des cookies pour améliorer votre expérience sur TutorMatch HEG 
              et analyser l'utilisation de notre site.
            </p>
            
            <div className="bg-blue-50 rounded-lg p-3 mb-4">
              <h4 className="text-sm font-medium text-blue-900 mb-2">
                <i className="fas fa-shield-alt text-blue-600 mr-2"></i>
                Vos données sont protégées
              </h4>
              <ul className="text-xs text-blue-800 space-y-1">
                <li>• Cookies essentiels pour le fonctionnement</li>
                <li>• Pas de partage avec des tiers</li>
                <li>• Conformité RGPD</li>
              </ul>
            </div>

            <p className="text-xs text-gray-500">
              En continuant, vous acceptez nos{' '}
              <Link 
                to="/conditions" 
                className="text-blue-600 hover:text-blue-800 font-medium underline decoration-blue-600 underline-offset-1"
                onClick={handleAccept}
              >
                conditions d'utilisation
              </Link>{' '}
              et notre{' '}
              <Link 
                to="/confidentialite" 
                className="text-blue-600 hover:text-blue-800 font-medium underline decoration-blue-600 underline-offset-1"
                onClick={handleAccept}
              >
                politique de confidentialité
              </Link>.
            </p>
          </div>

          {/* Boutons */}
          <div className="flex gap-3">
            <button
              onClick={handleDecline}
              className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
            >
              Refuser
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              <i className="fas fa-check mr-2"></i>
              Accepter
            </button>
          </div>
        </div>
      </div>
    </>
  );
};